import React, { useState } from "react";
import { IoHomeOutline } from "react-icons/io5";
import { LuUserRound } from "react-icons/lu";
import { BiBook } from "react-icons/bi";
import { RiServerLine } from "react-icons/ri";
import { BiMessageSquareDetail } from "react-icons/bi";
import { GoProject } from "react-icons/go";

function Navbar() {
  const [navlink, setnavlink] = useState("");
  return (
    <div>
      <nav>
        <a
          href="#"
          className={navlink == "#" ? "active" : ""}
          onClick={() => {
            setnavlink("#");
          }}
        >
          <IoHomeOutline />
        </a>
        <a
          href="#about"
          className={navlink == "#about" ? "active" : ""}
          onClick={() => {
            setnavlink("#about");
          }}
        >
          <LuUserRound />
        </a>
        <a
          href="#skills"
          className={navlink == "#skills" ? "active" : ""}
          onClick={() => {
            setnavlink("#skills");
          }}
        >
          <BiBook />
        </a>
        <a
          href="#services"
          className={navlink == "#services" ? "active" : ""}
          onClick={() => {
            setnavlink("#services");
          }}
        >
          <RiServerLine />
        </a>
        <a
          href="#projects"
          className={navlink == "#projects" ? "active" : ""}
          onClick={() => {
            setnavlink("#projects");
          }}
        >
          <GoProject />
        </a>
        <a
          href="#contact"
          className={navlink == "#contact" ? "active" : ""}
          onClick={() => {
            setnavlink("#contact");
          }}
        >
          <BiMessageSquareDetail />
        </a>
      </nav>
    </div>
  );
}

export default Navbar;
